import { PropsWithChildren, useEffect } from 'react'
import { RootState, useAppSelector } from '../utils/agent.store'
import { useNavigate } from 'react-router-dom'

const NavigateToPage: React.FC<{ url: string }> = ({ url }) => {
  const navigate = useNavigate()
  useEffect(() => {
    navigate(url)
  }, [url])
  return <></>
}

export const AdminProtectedRoute: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const isAdmin = useAppSelector(
    (state: RootState) => state.authUser.user?.superAdmin
  )

  if (!isAdmin) {
    return <NavigateToPage url="/" />
  } else {
    return children
  }
}
